import React from 'react';

const ProfileSchoolRow = ({school, ...props}) => {

    return (
        <div className="gap-4 py-6 flex">
            <div className="flex flex-col gap-1">
                <p className="font-lg font-bold">
                    {school.name}
                </p>
                <p>
                    Area of Study: {school.field_of_study}
                </p>
                {TB.moment(school.started_at).isValid() && (
                    <p className="text-wrippleBlueGray">
                        {TB.moment(school.started_at).format('ll')} - {TB.moment(school.ended_at).isValid() ? TB.moment(school.ended_at).format('ll') : 'Present'}
                    </p>
                )}

                <p>
                    {school.earned_degree}
                </p>
            </div>
        </div>
    )
};

export default ProfileSchoolRow;